import { render, staticRenderFns } from "./RunnitSelectedImage.vue?vue&type=template&id=71168874&scoped=true"
import script from "./RunnitSelectedImage.vue?vue&type=script&lang=ts"
export * from "./RunnitSelectedImage.vue?vue&type=script&lang=ts"
import style0 from "./RunnitSelectedImage.vue?vue&type=style&index=0&id=71168874&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71168874",
  null
  
)

export default component.exports